<template>
  <div style="padding: 5%">
    <h5>Notas Aclaratorias</h5>
    <div class="container-notas">
      <ul>
        <li>
          Si deja de comprar un mes, reinicia el conteo de últimos meses
        </li>
        <li>
          Si compra volumen menor a 1.2 hL reinicia el conteo de últimos meses
        </li>
        <li>
          Si no paga una deuda a tiempo sale de la lista de espera
        </li>
        <li>
          El cliente debe manejar un mix de SKUs >4
        </li>
        <li>
          El cliente debe tener compras estables mínimo 6 meses consecutivos
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

</script>
